/**
 * @Author: 王鹏
 * @Date: 2022-03-11 15:59:19
 * @LastEditors: 王鹏
 * @LastEditTime: 2022-03-11 17:17:41
 * @Description: 页面路由配置，参考：https://reactrouter.com/
 * @Rules: 为减少主包大小统一使用lazy方式引入页面
 */
import { lazy } from "react"
export interface iRouter {
  // ! url前面不需要加/
  url: string
  content: React.LazyExoticComponent<() => JSX.Element>
  title: string
  /**
   * status 状态描述
   * 1 开发中
   * 2 开发完成（不写默认是这个状态）
   * 3 测试完成
   * 4 已上线
   * 5 不显示在路由列表
   */
  status?: 1 | 2 | 3 | 4 | 5
  children?: Array<iRouter>
}

const config: Array<iRouter> = [
  {
    url: "/",
    content: lazy(() => import("./Home")),
    title: "路由列表",
    status: 5,
  },
  {
    url: "sms-protocol",
    content: lazy(() => import("./AgreementRulers/SmsProtocol")),
    title: "短信推送协议",
    status: 4,
  },
  {
    url: "luck",
    content: lazy(() => import("./Luck")),
    title: "幸运大转盘活动结束",
    status: 4,
  },
  {
    url: "law",
    content: lazy(() => import("./contract/law")),
    title: "合同-法律效力",
    status: 4,
  },
  {
    url: "e-contract",
    content: lazy(() => import("./contract/contract")),
    title: "电子合同",
    status: 4,
  },
  {
    url: "question",
    content: lazy(() => import("./contract/question")),
    title: "合同-常见问题",
    status: 4,
  },
  // 邀请工友送实物
  {
    url: "give-present",
    content: lazy(() => import("./NewSendGood/active")),
    title: "新-邀请工友领实物",
    status: 4,
  },
  {
    url: "give-present/convert-award/",
    content: lazy(() => import("./NewSendGood/convertAward")),
    title: "兑换奖品 ",
    status: 5,
  },
  {
    url: "give-present/convert-record/",
    content: lazy(() => import("./NewSendGood/convertRecord")),
    title: "兑换记录 ",
    status: 5,
  },
  {
    url: "give-present/address/",
    content: lazy(() => import("./NewSendGood/address")),
    title: "收货地址 ",
    status: 5,
  },
  {
    /* 重定向 http://m.yupao.com/invoice/index/ */
    url: "invoice/*",
    content: lazy(() => import("./Invoice")),
    title: "申请开票",
    status: 4,
    children: [
      {
        url: "index",
        content: lazy(() => import("./Invoice/NewInvoice")),
        title: "申请开票",
      },
      {
        url: "my",
        content: lazy(() => import("./Invoice/MyInvoice")),
        title: "我的发票",
      },
    ],
  },
  // 签署合同
  {
    url: "contract-success",
    content: lazy(() => import("./OnlineContract")),
    title: "签署合同",
    status: 4,
  },
  // 数字证书使用协议
  {
    url: "contract-agreement",
    content: lazy(() => import("./OnlineContract/UseAgreement")),
    title: "数字证书使用协议",
    status: 4,
  },
  {
    url: "virtual-phone",
    content: lazy(() => import("./VirtualPhone")),
    title: "中间号问题列表",
    status: 2,
  },
  {
    url: "virtual-detail",
    content: lazy(() => import("./VirtualPhone/detail")),
    title: "鱼泡安全号",
    status: 2,
  },
  // 协议政策相关
  {
    url: "logout/index/",
    content: lazy(() => import("./AgreementRulers/LoginoutExplain")),
    title: "注销说明",
    status: 4,
  },
  {
    url: "logout/agreement/",
    content: lazy(() => import("./AgreementRulers/LoginoutAgreement/index")),
    title: "注销协议",
    status: 4,
  },
  {
    url: "cameralogout/explain/",
    content: lazy(() => import("./AgreementRulers/CameraLoginoutExplain")),
    title: "水印相机注销说明",
    status: 4,
  },
  {
    url: "cameralogout/agreement/",
    content: lazy(() => import("./AgreementRulers/CameraLoginoutAgreement")),
    title: "水印相机注销协议",
    status: 4,
  },
  {
    url: "index/gdjgagreement/",
    content: lazy(() => import("./AgreementRulers/GdjgExplain/index")),
    title: "工地记工注销说明",
    status: 4,
  },
  {
    url: "index/gdjgagreements/",
    content: lazy(() => import("./AgreementRulers/Gdjgagreements")),
    title: "工地记工注销协议",
    status: 4,
  },
  {
    url: "user-agreement/",
    content: lazy(() => import("./AgreementRulers/UserAgreement")),
    title: "用户协议",
    status: 4,
  },
  {
    url: "index/otheruseragreementresume/",
    content: lazy(() => import("./AgreementRulers/AgreementResume")),
    title: "工地找活用户服务协议",
    status: 4,
  },
  {
    url: "index/otheruseragreementbookkeeping/",
    content: lazy(() => import("./AgreementRulers/AgreementBookkeeping")),
    title: "鱼泡记工记账用户服务协议",
    status: 4,
  },
  {
    url: "privacy-agreement/",
    content: lazy(() => import("./AgreementRulers/PrivacyAgreement")),
    title: "隐私政策",
    status: 4,
  },
  {
    url: "index/otherprivacyagreementresume/",
    content: lazy(() => import("./AgreementRulers/PrivacyagreementResume")),
    title: "工地找活用户隐私政策",
    status: 4,
  },
  {
    url: "index/otherprivacyagreement/",
    content: lazy(() => import("./AgreementRulers/PrivacyagreementNote")),
    title: "工地记工用户隐私政策",
    status: 4,
  },
  {
    url: "index/otherprivacyagreementbookkeeping/",
    content: lazy(() => import("./AgreementRulers/PrivacyagreementBookkeeping")),
    title: "记工记账用户隐私政策",
    status: 4,
  },
  {
    url: "index/otheruseragreementcamera/",
    content: lazy(() => import("./AgreementRulers/UseragreementCamera")),
    title: "鱼泡水印相机（服务协议）",
    status: 4,
  },
  {
    url: "index/otherprivacyagreementcamera/",
    content: lazy(() => import("./AgreementRulers/PrivacyagreementCamera")),
    title: "鱼泡水印相机（隐私政策）",
    status: 4,
  },
  {
    url: "rules/position-rule/",
    content: lazy(() => import("./AgreementRulers/PositionRule")),
    title: "位置权限信息使用规则",
    status: 4,
  },
  {
    url: "rules/camera-rule/",
    content: lazy(() => import("./AgreementRulers/CameraRule")),
    title: "相机功能使用规则",
    status: 4,
  },
  {
    url: "rules/microphone-rule/",
    content: lazy(() => import("./AgreementRulers/MicrophoneRule")),
    title: "麦克风功能使用规则",
    status: 4,
  },
  {
    url: "rules/device-rule/",
    content: lazy(() => import("./AgreementRulers/DeviceRule")),
    title: "获取设备状态权限使用规则",
    status: 4,
  },
  {
    url: "rules/storage-rule/",
    content: lazy(() => import("./AgreementRulers/StorageRule")),
    title: "文件存储和访问权限使用规则",
    status: 4,
  },
  {
    url: "index/otherfaceagreement/",
    content: lazy(() => import("./AgreementRulers/FaceAgreement")),
    title: "人脸认证授权服务协议",
    status: 4,
  },
  {
    url: "member/task-rule/",
    content: lazy(() => import("./AgreementRulers/Membertaskrule")),
    title: "任务中心查看规则",
    status: 4,
  },
  {
    url: "index/otheruseragreement/",
    content: lazy(() => import("./AgreementRulers/GongdiUseragreement")),
    title: "工地记工服务协议",
    status: 4,
  },
  {
    url: "index/otherinvitefriendruler/",
    content: lazy(() => import("./AgreementRulers/InvitefriendRuler")),
    title: "邀请好友赚积分规则",
    status: 4,
  },
  {
    url: "index/otherzhaogongruler/",
    content: lazy(() => import("./AgreementRulers/ZhaogongRuler")),
    title: "鱼泡直聘职位信息发布规则 ",
    status: 4,
  },
  {
    url: "index/otherzhaohuoruler/",
    content: lazy(() => import("./AgreementRulers/ZhaohuoRuler")),
    title: "鱼泡直聘找活名片发布规则 ",
    status: 4,
  },
  {
    url: "index/ios-about-us/",
    content: lazy(() => import("./AgreementRulers/IosAboutus")),
    title: "机械相关 关于我们 ",
    status: 4,
  },
  // 邀请工友赚现金
  {
    url: "activity-exclusive/invite-workmate/",
    content: lazy(() => import("./Activity/Index")),
    title: "邀请工友赚现金 ",
    status: 4,
  },
  // 邀请工友送实物
  {
    url: "sendgoods",
    content: lazy(() => import("./SendGoods/Index")),
    title: "鱼泡送工服",
    status: 4,
  },
  {
    url: "sendgoods/convert-award/",
    content: lazy(() => import("./SendGoods/convertAward")),
    title: "兑换奖品 ",
    status: 5,
  },
  {
    url: "sendgoods/convert-record/",
    content: lazy(() => import("./SendGoods/convertRecord")),
    title: "兑换记录 ",
    status: 5,
  },
  {
    url: "sendgoods/address/",
    content: lazy(() => import("./SendGoods/address")),
    title: "收货地址 ",
    status: 5,
  },

  {
    url: "activity-exclusive/award-detail/",
    content: lazy(() => import("./Activity/awardDetail")),
    title: "奖励明细 ",
    status: 5,
  },
  {
    url: "activity-exclusive/withdrawal-record/",
    content: lazy(() => import("./Activity/withdrawalRecord")),
    title: "提现记录 ",
    status: 5,
  },
  {
    url: "activity-exclusive/total-record/",
    content: lazy(() => import("./Activity/totalRecord")),
    title: "全部提现记录 ",
    status: 5,
  },
  {
    url: "activity-exclusive/apply-withdrawal/",
    content: lazy(() => import("./Activity/applyWithdrawal")),
    title: "申请明细 ",
    status: 5,
  },
  {
    url: "activity-exclusive/withdrawal-details/",
    content: lazy(() => import("./Activity/withdrawalDetails")),
    title: "提现详情 ",
    status: 5,
  },
  {
    url: "RealNameAgreement",
    content: lazy(() => import("./AgreementRulers/RealNameAgreement/index")),
    title: "服务协议",
    status: 4,
  },
  {
    url: "integral/agreement",
    content: lazy(() => import("./IntegralAgreement")),
    title: "用户充值协议",
    status: 4,
  },
  {
    url: "user-rights/",
    content: lazy(() => import("./AgreementRulers/UserRights")),
    title: "用户协议",
    status: 4,
  },
  {
    url: "page-warning",
    content: lazy(() => import("./pageWarning")),
    title: "鱼泡网",
    status: 4,
  },
]

export default config
